/** 编辑器mock插件在初始化阶段注入 mocked的 uctag到数据源上 */
export const UC_TAG_MOCKED = 'mocked';

/** 用于标记在作用插槽/子renderer里的schema */
export const UC_TAG_SCOPEDSCHEMA = 'uc:scopedSchema';
